import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { FirebaseConfig } from '../config/firebase';

const firebaseConfig = FirebaseConfig;
const apps = getApps();
const app = apps.length ? apps[0] : initializeApp(firebaseConfig);

const db = getFirestore(app);

export { db };
